import styled from 'styled-components';

import { spaceXL } from '@xing-com/tokens';

export const StyledRecaptchaContainer = styled.div`
  margin: ${spaceXL} 0;
`;
